"use client";
import BlokWrap from "@/components/bloks/BlokWrap";
import { Button } from "@/components/ui/Button";
import type { BlokArticleHeader } from "@/storyblok";

import type { BlokProps } from "@frend-digital/storyblok";
import styles from "./ArticleHeader.module.css";
import { useUrlSearchParams } from "@frend-digital/ui/next";
import { Suspense, useState } from "react";
import { Translate } from "@/components/Translate";

export const ArticleHeaderBlok = ({
	blok,
	preview,
	...rest
}: BlokProps<BlokArticleHeader> & { tags?: string[] }) => {
	const { tags = [] } = rest;

	return (
		<BlokWrap {...rest} editable={blok} asChild>
			<div className={styles.subgrid}>
				<h1 className={styles.title}>{blok.title}</h1>
				{blok.preamble && <p className={styles.preamble}>{blok.preamble}</p>}
				<div className={styles.content}>
					<div className={styles.tags}>
						<div className={styles.tags}>
							{tags.map((tag) => (
								<Suspense key={tag}>
									<TagButton tag={tag} />
								</Suspense>
							))}
						</div>
					</div>
				</div>
			</div>
		</BlokWrap>
	);
};

const TagButton = ({ tag }: { tag: string }) => {
	const searchParams = useUrlSearchParams({
		replace: true,
		scroll: false,
	});

	const selectedTags = searchParams.getAll("tag");

	const handleTagSelect = (tag: string) => {
		const newTags = selectedTags.includes(tag)
			? selectedTags.filter((t) => t !== tag)
			: [...selectedTags, tag];

		searchParams.delete("tag");
		newTags.forEach((newTag) => {
			searchParams.append("tag", newTag);
		});
	};
	return (
		<Button
			onClick={() => handleTagSelect(tag)}
			href={`?tag=${encodeURIComponent(tag)}`}
			className={`${styles.tag} ${selectedTags.includes(tag) ? styles.activeTag : ""}`}
		>
			<Translate>{tag}</Translate>
		</Button>
	);
};
